/* eslint-disable react/prop-types, react/destructuring-assignment */
import clsx from 'clsx'
import { Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Alert, Button, Col, Form, Modal, Row } from 'react-bootstrap'
import { FormattedMessage, injectIntl } from 'react-intl'
import Select, { components } from 'react-select'
import { selectStyle } from '../../../../_augmentt/utils/styles'
import ScrollMenu from '../../../partials/content/ScrollMenu'

function FindEmployeeModal(props) {
  const { showFindEmployeeModal, onHideFindEmployeeModal, onEmployeeSelect, intl, employees } = props

  // Local state
  const [employeeOptions, setEmployees] = useState([])
  const [originalEmployeeOptions, setOriginalEmployeeOptions] = useState([])
  const [departmentOptions, setDepartments] = useState([])
  const [originalDepartmentOptions, setOriginalDepartmentOptions] = useState([])
  const [jobTitleOptions, setJobTitles] = useState([])
  const [originalJobTitleOptions, setOriginalJobTitleOptions] = useState([])

  const [departmentFilter, setDepartmentFilter] = useState([])
  const [jobTitleFilter, setJobTitleFilter] = useState([])

  const [status, setStatus] = useState()

  const initialValues = {
    department: [],
    jobTitle: [],
  }

  // Option component override
  // eslint-disable-next-line react/no-unstable-nested-components, no-shadow
  function Option({ children, ...props }) {
    const { data } = props

    const onClick = (e) => {
      props.selectOption({ ...data })
      e.stopPropagation()
      e.preventDefault()
    }

    return (
      <components.Option {...props}>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
        <div className="select-option" onClick={onClick}>
          {props.data.label ? props.data.label : `${props.data.firstName} ${props.data.lastName}`}
          {props.data.email && <span className="ps-2 font-color-1 nowrap">({props.data.email})</span>}
        </div>
      </components.Option>
    )
  }

  useEffect(() => {
    if (showFindEmployeeModal) {
      // eslint-disable-next-line no-use-before-define
      populateSelectBoxes()
    }
  }, [showFindEmployeeModal]) // eslint-disable-line react-hooks/exhaustive-deps

  // Handles setting the job title filter options
  useEffect(() => {
    let filteredJobTitleOptions = jobTitleOptions

    if (!departmentFilter.length) {
      // Reset the job title options
      setJobTitles(originalJobTitleOptions)
      return
    }

    filteredJobTitleOptions = filteredJobTitleOptions.filter((jobTitle) =>
      employeeOptions.some((employee) => employee.value.jobTitle === jobTitle.value),
    )
    setJobTitles(filteredJobTitleOptions)
  }, [departmentFilter]) // eslint-disable-line react-hooks/exhaustive-deps

  // Handles setting the department filter options
  useEffect(() => {
    let filteredDepartmentOptions = departmentOptions

    if (!jobTitleFilter.length) {
      // Reset the department options
      setDepartments(originalDepartmentOptions)
      return
    }

    filteredDepartmentOptions = filteredDepartmentOptions.filter((department) =>
      employeeOptions.some((employee) => employee.value.department === department.value),
    )
    setDepartments(filteredDepartmentOptions)
  }, [jobTitleFilter]) // eslint-disable-line react-hooks/exhaustive-deps

  // Populate select boxes
  const populateSelectBoxes = () => {
    const options = []
    let deptOptions = []
    // eslint-disable-next-line no-shadow
    let jobTitleOptions = []

    // eslint-disable-next-line no-restricted-syntax
    for (const employee of employees) {
      if (employee.firstName && employee.lastName) {
        options.push({
          value: employee,
          label: `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
        })
        if (employee.department) {
          deptOptions.push({
            value: employee.department,
            label: employee.department,
          })
        }
        if (employee.jobTitle) {
          jobTitleOptions.push({
            value: employee.jobTitle,
            label: employee.jobTitle,
          })
        }
      }
    }

    // Sort, remove duplicates
    options.sort((a, b) => a.label.localeCompare(b.label))
    deptOptions.sort((a, b) => a.label.localeCompare(b.label))
    deptOptions = deptOptions.filter((v, i, a) => a.findIndex((t) => t.label === v.label) === i)
    jobTitleOptions.sort((a, b) => a.label.localeCompare(b.label))
    jobTitleOptions = jobTitleOptions.filter((v, i, a) => a.findIndex((t) => t.label === v.label) === i)

    setEmployees(options)
    setOriginalEmployeeOptions(options)
    setDepartments(deptOptions)
    setOriginalDepartmentOptions(deptOptions)
    setJobTitles(jobTitleOptions)
    setOriginalJobTitleOptions(jobTitleOptions)
  }

  // Update filter
  const updateFilter = (type, value) => {
    let filteredEmployees = employeeOptions
    let departmentOptions = departmentOptions // eslint-disable-line

    if (type === 'department') {
      const departmentFilterValue = value || []
      setDepartmentFilter(departmentFilterValue)

      // Department filter has been cleared, reset employeeOptions back to job title filtered employees or originalEmployeeOptions
      if (!departmentFilterValue.length) {
        if (!jobTitleFilter.length) {
          filteredEmployees = originalEmployeeOptions
        } else {
          updateFilter('jobTitle', jobTitleFilter)
        }
      } else {
        // Filter by department
        // eslint-disable-next-line no-restricted-syntax
        for (const department of departmentFilterValue) {
          filteredEmployees = filteredEmployees.filter((e) => e.value.department === department.label)
        }
      }
    } else {
      const jobTitleFilterValue = value || []
      setJobTitleFilter(jobTitleFilterValue)

      // Job title filter has been cleared, reset employeeOptions back to department filtered employees or originalEmployeeOptions
      if (!jobTitleFilterValue.length) {
        if (!departmentFilter.length) {
          filteredEmployees = originalEmployeeOptions
        } else {
          updateFilter('department', departmentFilter)
        }
      } else {
        // eslint-disable-next-line no-restricted-syntax
        for (const title of jobTitleFilterValue) {
          filteredEmployees = filteredEmployees.filter((e) => e.value.jobTitle === title.label)
        }
      }
    }
    setEmployees(filteredEmployees)
  }

  const onSelect = (employee) => {
    onEmployeeSelect(employee)
    // eslint-disable-next-line no-use-before-define
    hide()
  }

  const hide = () => {
    onHideFindEmployeeModal()
    setStatus()
  }

  return (
    <Modal
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={showFindEmployeeModal}
      onHide={hide}
      onSubmit={onSelect}
      id="findEmployeeModal"
      backdrop={false}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <FormattedMessage id="ENGAGE.FIND_AN_EMPLOYEE" />
        </Modal.Title>
      </Modal.Header>

      <Formik initialValues={initialValues} onSubmit={(values) => onSelect(values)}>
        {({ handleSubmit, setFieldValue, setFieldTouched, values, errors }) => (
          <Form>
            <Modal.Body>
              <Row className="justify-content-center align-items-center">
                {status && (
                  <Alert variant={errors ? 'danger' : 'success'}>
                    <div className="alert-text">{status}</div>
                  </Alert>
                )}
                <Row style={{ width: '100%' }}>
                  <Form.Group as={Col} md="12" controlId="employee">
                    <p className="mb-4">
                      {intl.formatMessage({
                        id: 'ENGAGE.FIND_AN_EMPLOYEE_DESC',
                      })}
                    </p>
                    <Select
                      name="department"
                      styles={selectStyle}
                      className="inline mb-3"
                      options={departmentOptions}
                      value={values.department}
                      isMulti
                      onChange={(value) => {
                        setFieldValue('department', value)
                        updateFilter('department', value)
                      }}
                      onBlur={() => setFieldTouched('department', true)}
                      placeholder={intl.formatMessage({
                        id: 'PLACEHOLDER.FILTER_BY_DEPARTMENT',
                      })}
                      components={{ MenuList: ScrollMenu }}
                    />
                    <Select
                      name="jobTitle"
                      styles={selectStyle}
                      className="inline mb-3"
                      options={jobTitleOptions}
                      value={values.jobTitle}
                      isMulti
                      onChange={(value) => {
                        setFieldValue('jobTitle', value)
                        updateFilter('jobTitle', value)
                      }}
                      onBlur={() => setFieldTouched('jobTitle', true)}
                      placeholder={intl.formatMessage({
                        id: 'PLACEHOLDER.FILTER_BY_JOBTITLE',
                      })}
                      components={{ MenuList: ScrollMenu }}
                    />
                    <p className="mb-4">
                      {intl.formatMessage({
                        id: 'ENGAGE.SELECT_EMPLOYEE_EMAIL_PASSWORD',
                      })}
                    </p>
                    <Select
                      name="employee"
                      styles={selectStyle}
                      className="inline"
                      options={employeeOptions}
                      value={values.employee}
                      isMulti={false}
                      isClearable
                      onChange={(value) => {
                        setFieldValue('employee', value, false)
                      }}
                      onBlur={() => setFieldTouched('employee', true)}
                      placeholder={intl.formatMessage({
                        id: 'PLACEHOLDER.SELECT_EMPLOYEE',
                      })}
                      components={{ MenuList: ScrollMenu, Option }}
                    />
                  </Form.Group>
                </Row>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={hide} variant="light">
                <FormattedMessage id="GENERAL.CANCEL" />
              </Button>
              <Button
                onClick={handleSubmit}
                disabled={!values.employee}
                id="nextBtn"
                variant="primary"
                className={`${clsx({
                  'spinner spinner--right spinner--md spinner--light': null,
                })}`}
              >
                <FormattedMessage id="PLACEHOLDER.SELECT_EMPLOYEE" />
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default injectIntl(FindEmployeeModal)
